import { useCallback } from 'react'

export interface IPropsToogle {
  bgClassName?: string
  toggled?: boolean
  size?: 'sm' | 'md'
  disabled?: boolean
  onClick: () => void
}

export const Toggle = ({
  bgClassName = 'bg-gray',
  disabled,
  size = 'md',
  toggled,
  onClick,
}: IPropsToogle) => {
  const handleClick = useCallback(() => {
    if (!disabled) onClick?.()
  }, [disabled, onClick])

  return (
    <button
      data-testid="toggle"
      onClick={handleClick}
      className={[
        'p-1 rounded-3xl flex transition-all duration-300  cursor-pointer',
        size === 'md' ? 'h-8  w-[3.75rem] ' : 'h-6 w-10',
        toggled ? bgClassName : 'bg-gray',
        disabled ? '!bg-gray !cursor-default' : '',
      ].join(' ')}
    >
      <div
        className={[
          ' rounded-full transition-all duration-150 ',
          size === 'md' ? 'w-6 h-6' : ' w-4 h-4',
          size === 'sm' && toggled ? 'translate-x-4' : 'translate-x-0',
          size === 'md' && toggled ? 'translate-x-7' : 'translate-x-0',
          disabled ? '!bg-gray' : '',
          toggled ? 'bg-black' : 'bg-white',
        ].join(' ')}
      ></div>
    </button>
  )
}


export default Toggle
